/**
 * Para «Compartir con mi cliente» de OPUS ci (CompartirConCliente.tsx, de Sebastián): «Enviar desde
 * mi correo» y «Enviar por WhatsApp» con el MISMO texto que él ya redacta, por la cuenta del usuario
 * (docs/29 F3). Los botones de siempre (mailto / wa.me / copiar) se quedan como respaldo.
 *
 * Todo vive aquí para que el cambio en su archivo sea una línea de import y un elemento.
 * Si Mensajes no está disponible en el hub, no se pinta nada.
 */
import { useState } from 'react';
import { Button } from '@fluentui/react-components';
import { Chat20Regular, Mail20Regular } from '@fluentui/react-icons';
import { useMensajes } from '../../lib/mensajesDisponibles.js';
import type { CanalDeEnvio } from '../../lib/enviarMensaje.js';
import { EnviarDialog } from './EnviarDialog.js';

export interface EnviarDesdeMiCuentaProps {
  /** Id del enlace (bitácora). */
  refEnlace: string;
  url: string;
  titulo: string;
  cliente?: string | null;
  correo?: string;
  whatsapp?: string;
  asunto: string;
  mensajeCorreo: string;
  mensajeWhatsApp: string;
}

export function EnviarDesdeMiCuenta(p: EnviarDesdeMiCuentaProps): JSX.Element | null {
  const { disponible } = useMensajes();
  const [canal, setCanal] = useState<CanalDeEnvio | null>(null);
  if (!disponible) return null;
  const nombre = p.cliente?.trim() ?? '';
  const contacto = canal === 'whatsapp' ? (p.whatsapp ?? '') : (p.correo ?? '');
  return (
    <div style={{ display: 'grid', rowGap: 6 }}>
      <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}>
        O envíalo tú mismo desde tu cuenta, sin salir de OPUS:
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        <Button appearance="primary" icon={<Mail20Regular />} onClick={() => setCanal('correo')}>
          Enviar desde mi correo
        </Button>
        <Button appearance="primary" icon={<Chat20Regular />} onClick={() => setCanal('whatsapp')}>
          Enviar por WhatsApp
        </Button>
      </div>
      <EnviarDialog
        abierto={canal !== null}
        onCerrar={() => setCanal(null)}
        titulo="Enviar a mi cliente"
        canalInicial={canal ?? 'correo'}
        origen={{ app: 'ci', ref: p.refEnlace }}
        para={nombre || contacto ? [{ nombre, contacto }] : undefined}
        asunto={p.asunto}
        mensaje={p.mensajeCorreo}
        mensajeWhatsApp={p.mensajeWhatsApp}
        enlace={{ url: p.url, titulo: p.titulo }}
        permitirAdjuntar={false}
      />
    </div>
  );
}
